import React from 'react'
import Communication from '../Communication/Communication'

const Education = () => {
  return (
    
    <div className='education'>
     <Communication></Communication>
    </div>
  )
}

export default Education